import { render, staticRenderFns } from "./CounselingQuestionOptionTimeAgoText.vue?vue&type=template&id=36735de6&"
import script from "./CounselingQuestionOptionTimeAgoText.vue?vue&type=script&lang=js&"
export * from "./CounselingQuestionOptionTimeAgoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports